import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getBadge = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/badges/${id}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_BADGE,
                payload: {
                    badge: body
                }
            });
        });
};

export const deleteBadge = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.adminServerUrl}/badges/${id}`, { method: 'DELETE' }).then((body) => {
            dispatch({
                type: ACTIONS.DELETE_BADGE,
                payload: {
                    badge: body
                }
            });
        });
};

export const getManyBadges = (params) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.serverUrl}/badges`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url)
            .then((body) => {
                dispatch({
                    type: ACTIONS.GET_MANY_BADGES,
                    payload: {
                        badges: body
                    }
                });
                return body;
            })
            .catch(console.error);
};

export const putBadge = (params) => {
    const { id, body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/badges/${id}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_BADGE_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.PUT_BADGE_SUCCESS,
                    payload: {
                        badge: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};

export const postBadge = (params) => {
    const { body, pathsContext } = params;
    const uri = `${pathsContext.adminServerUrl}/badges`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_BADGE_START,
            payload: {
                body
            }
        });
        return VerbFetch(uri, fetchOptions)
            .then((response) => {
                dispatch({
                    type: ACTIONS.POST_BADGE_SUCCESS,
                    payload: {
                        badge: response
                    }
                });
                return response;
            })
            .catch((err) => err);
    };
};
